var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrXComputer = function SvgBrXComputer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7146 52.3438H6.28544C5.12969 52.3438 4.18959 51.4058 4.1875 50.25H62.8125C62.8104 51.4058 61.8703 52.3438 60.7146 52.3438ZM62.8125 46.0625V38.7344H58.625V46.0625H8.375V16.7521C8.375 15.5963 9.31509 14.6562 10.4708 14.6562H56.5292C57.6849 14.6562 58.625 15.5963 58.625 16.7521V30.3594H62.8125V16.7521C62.8125 13.289 59.9922 10.4688 56.5292 10.4688H10.4708C7.00778 10.4688 4.1875 13.289 4.1875 16.7521V46.0625H0V50.2458C0 53.711 2.82028 56.5312 6.28544 56.5312H60.7146C64.1797 56.5312 67 53.711 67 50.2458V46.0625H62.8125Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9409 24.0044L33.5 28.4452L29.0592 24.0044L26.0986 26.965L30.5395 31.4058L26.0986 35.8466L29.0592 38.8072L33.5 34.3664L37.9409 38.8072L40.9014 35.8466L36.4606 31.4058L40.9014 26.965L37.9409 24.0044Z",
    fill: "#0157FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrXComputer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "BR_X_COMPUTER.d213d3cfea1fd9e1fc68bfb88d5642cc.svg";